/**
 * Google sign-in leaves the app and comes back to /login/google without our
 * query string, so the ?redirect= target (e.g. an MCP consent page) is kept in
 * sessionStorage across the round trip.
 */
export const LOGIN_REDIRECT_KEY = 'login-redirect';

type Storage = Pick<globalThis.Storage, 'getItem' | 'setItem' | 'removeItem'>;

/** Before leaving for Google: remember ?redirect= from the current URL, or clear a stale one. */
export const rememberLoginRedirect = (search: string, storage: Storage) => {
  const redirect = new URLSearchParams(search).get('redirect');
  if (redirect) {
    storage.setItem(LOGIN_REDIRECT_KEY, redirect);
  } else {
    storage.removeItem(LOGIN_REDIRECT_KEY);
  }
};

/** Back from Google: the /login URL to restore, with ?redirect= if one was remembered. Single use. */
export const takeLoginPath = (storage: Storage): string => {
  const redirect = storage.getItem(LOGIN_REDIRECT_KEY);
  storage.removeItem(LOGIN_REDIRECT_KEY);
  return redirect
    ? `/login?redirect=${encodeURIComponent(redirect)}`
    : '/login';
};
